module.exports = __webpack_public_path__ + "img/logo.63b161cf.png";